// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"3e2e6c6f","315":"4a38d7ad","409":"051876e7","631":"1bfa3bd4","760":"18250a5a","771":"7e5919fc","774":"859f51b1","787":"8127ce38"}[chunkId] + ".chunk.js";
};